var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ptb-100"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card border-primary"},[_c('div',{staticClass:"row no-gutters"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }